<ng-container *transloco="let t; prefix: 'dashboardSearch'">
  <rma-icon glyph="rma-no-search-results" theme="primary" size="large" />
  <h3>{{ t('no-results-found') }}</h3>
  <p>{{ t('try-refining') }}</p>
</ng-container>
